import React, { useEffect, useMemo, useState } from 'react';
import searchIcon from "../../asset/images/search-icon.svg";
import rightIcon from "../../asset/images/right-tick-green.svg";
import rightTick from "../../asset/images/right-tick-red.svg";

const RejectedBrokerage = () => {

  const [statsData, setStatsData] = useState([]);
  const [name, setName] = useState("");

  const data = [
    {
      key: "1",
      del: "₹10/trade",
      intraday: "₹10/trade",
      futures: "₹14/contract",
      options: "₹14/contract",
      dpc: "₹10/annum",
      rmName: "Avinash Shukla",
      date: "23-09-24",
      status: "Approved",
      remarks: "FNO charges to be changed"
    },
    {
      key: "2",
      del: "₹20/trade",
      intraday: "₹20/trade",
      futures: "₹16/contract",
      options: "₹16/contract",
      dpc: "₹20/annum",
      rmName: "Rohit jadhav",
      date: "23-10-24",
      status: "Rejected",
      remarks: "FNO charges to be changed"
    },
    {
      key: "3",
      del: "₹30/trade",
      intraday: "₹30/trade",
      futures: "₹17/contract",
      options: "₹17/contract",
      dpc: "₹30/annum",
      rmName: "Anik shah",
      date: "30-09-24",
      status: "Approved",
      remarks: "FNO charges to be changed"
    },
  ];

  useEffect(() => {
    setStatsData(data);
  }, []);

  const ascendingOrder = () => {
    let ascendingItems = [...statsData].sort((a, b) => a.key - b.key);
    setStatsData([...ascendingItems]);
  };

  const descendingOrder = () => {
    let descendingItems = [...statsData].sort((a, b) => b.key - a.key);
    setStatsData([...descendingItems]);
  };

  const results = useMemo(() => {
    if (name === "") {
      return statsData;
    } else if (statsData && statsData?.length > 0) {
      return statsData?.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(name.toLowerCase())
        )
      );
    }
  }, [name, statsData]);


  return (
    <div className='approved-page'>
      <div className='approved-wrapper bottom-25'>
        <div className='search-wrapper'>
          <img src={searchIcon} alt="search" />
          <input
            className='personal-form-input'
            type="text"
            placeholder='Search here'
            value={name}
            onChange={(e) => {
              setName(e?.target?.value);
              // setPage(1);
            }}
          />
        </div>

      </div>

      <div className="brokerage-table">
        <table class="table">
          <thead>
            <tr>
              <th>
                <span className='wrap-th'>
                  <span>Delivery </span>
                  <span className='wrap-icons'>
                    <span
                      className="icon-up-triangle"
                    onClick={() => descendingOrder()}
                    ></span>
                    <span
                      className="icon-down-triangle"
                    onClick={() => ascendingOrder()}
                    ></span>
                  </span>
                </span>
              </th>
              <th>
                <span className='wrap-th'>
                  <span>Intraday</span>
                  <span className='wrap-icons'>
                    <span
                      className="icon-up-triangle"
                    onClick={() => descendingOrder()}
                    ></span>
                    <span
                      className="icon-down-triangle"
                    onClick={() => ascendingOrder()}
                    ></span>
                  </span>
                </span>
              </th>
              <th>
                <span className='wrap-th'>
                  <span>Futures</span>
                  <span className='wrap-icons'>
                    <span
                      className="icon-up-triangle"
                    onClick={() => descendingOrder()}
                    ></span>
                    <span
                      className="icon-down-triangle"
                    onClick={() => ascendingOrder()}
                    ></span>
                  </span>
                </span>
              </th>
              <th>
                <span className='wrap-th'>
                  <span>Options</span>
                  <span className='wrap-icons'>
                    <span
                      className="icon-up-triangle"
                    onClick={() => descendingOrder()}
                    ></span>
                    <span
                      className="icon-down-triangle"
                    onClick={() => ascendingOrder()}
                    ></span>
                  </span>
                </span>
              </th>
              <th>
                <span className='wrap-th'>
                  <span>DPC</span>
                  <span className='wrap-icons'>
                    <span
                      className="icon-up-triangle"
                    onClick={() => descendingOrder()}
                    ></span>
                    <span
                      className="icon-down-triangle"
                    onClick={() => ascendingOrder()}
                    ></span>
                  </span>
                </span>
              </th>
              <th>
                <span className='wrap-th'>
                  <span>RM Name</span>
                  <span className='wrap-icons'>
                    <span
                      className="icon-up-triangle"
                    onClick={() => descendingOrder()}
                    ></span>
                    <span
                      className="icon-down-triangle"
                    onClick={() => ascendingOrder()}
                    ></span>
                  </span>
                </span>
              </th>
              <th>
                <span className='wrap-th'>
                  <span>Date</span>
                  <span className='wrap-icons'>
                    <span
                      className="icon-up-triangle"
                    onClick={() => descendingOrder()}
                    ></span>
                    <span
                      className="icon-down-triangle"
                    onClick={() => ascendingOrder()}
                    ></span>
                  </span>
                </span></th>
              <th><span className='wrap-th'>
                <span>Status</span>
                <span className='wrap-icons'>
                  <span
                    className="icon-up-triangle"
                  onClick={() => descendingOrder()}
                  ></span>
                  <span
                    className="icon-down-triangle"
                  onClick={() => ascendingOrder()}
                  ></span>
                </span>
              </span></th>

              <th><span className='wrap-th'>
                <span>Remarks</span>
                <span className='wrap-icons'>
                  <span
                    className="icon-up-triangle"
                  onClick={() => descendingOrder()}
                  ></span>
                  <span
                    className="icon-down-triangle"
                  onClick={() => ascendingOrder()}
                  ></span>
                </span>
              </span></th>
            </tr>
          </thead>
          <tbody>
            {results && results.map((item, index)=>{
              return(
                <tr>
                  <td>{item?.del || "-"}</td>
                  <td>{item?.intraday || "-"}</td>
                  <td>{item?.futures || "-"}</td>
                  <td>{item?.options || "-"}</td>
                  <td>{item?.dpc || "-"}</td>
                  <td>{item?.rmName || "-"}</td>
                  <td>{item?.date || "-"}</td>
                  <td className={item?.status === "Approved" ? `active-status` : 'inactive-status'}>{item?.status || "-"}</td>
                  <td>{item?.remarks || "-"}</td>
                </tr>
              )
            })}
          </tbody>
        </table>

        <div class="pagination">
          <span>Items per page</span>
          <select>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </select>
          <span>1-10 items</span>
        </div>

      </div>
    </div>
  )
}

export default RejectedBrokerage